<template>
  <div class="postcode-lookup__addresses" :class="`postcode-lookup__addresses--${theme}`">
    <div v-if="hasSearch" class="postcode-lookup__filter">
      <input
        v-model="searchValModel"
        :placeholder="placeholderText"
        type="text"
        class="postcode-lookup__filter-input"
        :class="{ 'postcode-lookup__filter-input--prepend': prependSearchIcon }"
        aria-label="Address search filter"
      >
      <img
        src="../assets/icons/magnifying-glass.svg"
        alt="magnifying glass icon"
        class="postcode-lookup__filter-icon"
        :class="{ 'postcode-lookup__filter-icon--prepend': prependSearchIcon }"
      >
    </div>
    <div class="postcode-lookup__address-list">
      <component
        :is="itemComponent"
        v-for="address of addresses"
        :key="address.id"
        :address="address"
        :filter-string="value"
        :address-item-icon="addressItemIcon"
        class="postcode-lookup__address-item postcode-lookup__address-item--address"
        :use-address-item-icon="useAddressItemIcon"
        @click.native="submit(address)"
      />
    </div>
    <div
      v-if="hasManual"
      class="postcode-lookup__address-item postcode-lookup__address-item--manual"
      @click="showManual"
    >
      {{ (typeof hasManual === 'string') ? hasManual : 'My address is not listed - Enter it manually' }}
    </div>
  </div>
</template>

<script>
import modelize from '../helpers/modelize'
import AddressListItem from './AddressListItem'

export default {
  name: 'AddressList',

  props: {
    addresses: {
      type: Array,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    itemComponent: {
      type: Object,
      default: () => AddressListItem
    },
    hasManual: {
      type: [String, Boolean],
      default: true
    },
    hasSearch: {
      type: Boolean,
      default: true
    },
    addressItemIcon: {
      type: String,
      default: 'caret-right-circle.svg'
    },
    useAddressItemIcon: {
      type: Boolean,
      default: true
    },
    prependSearchIcon: {
      type: Boolean,
      default: false
    },
    placeholderText: {
      type: String,
      default: 'Search...'
    },
    theme: {
      type: String,
      default: ''
    }
  },

  computed: {
    ...modelize('searchValModel')
  },

  methods: {
    submit (address) {
      this.$emit('submit', address)
    },

    showManual () {
      this.$emit('manual:show')
    }
  }
}
</script>

<style lang="scss">
.postcode-lookup__addresses--purple .postcode-lookup__address-item .address-item__text {
    color: $purple-2;
}

</style>

<style lang="scss" scoped>
.postcode-lookup {
  &__filter {
    position: relative;
    display: flex;
    align-items: center;
  }

  &__filter-input {
    width: 100%;
    border: 0;
    padding: $spacing-20 $spacing-40;
    border-bottom: 2px solid #eee;
    background-color: $white;
    outline: 0;

    &--prepend {
      padding: $spacing-20 $spacing-67;
    }
  }

  &__filter-icon {
    position: absolute;
    right: $spacing-52;

    &--prepend {
      left: $spacing-30;
      @media (max-width: $screen-md) {
        left: $spacing-16;
      }
    }

    @media (max-width: $screen-md) {
      right: $spacing-16;
    }
  }

  &__addresses {
    width: 100%;
    margin-top: $spacing-24;
    box-shadow: $shadow-light;
    border-radius: $border-radius-medium;
    background-color: $white;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  &__address-list {
    max-height: 222px;
    overflow: auto;

    @media (min-height: $screen-height-md) {
      min-height: 370px;
    }
  }

  &__address-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: $spacing-16 $spacing-40;
    text-align: left;
    border-bottom: 2px solid #eee;
    cursor: pointer;
    font-size: 18px;
    font-weight: 500;
    color: $address-item-text;

    &:hover {
      background-color: #fafafa;
    }

    &--manual {
      padding: $spacing-20 $spacing-40;
      border-top: 3px solid $address-manual-border;
      color: $address-manual-text;
      font-weight: 700;
      width: 100%;
      background-color: $white;
    }
  }

  @media (max-width: $screen-md) {
    &__filter-input,
    &__address-item {
      padding: $spacing-16 $spacing-16;
      font-size: 14px;
      line-height: 18px;

      &--prepend {
        padding: $spacing-20 $spacing-46;
      }
    }

    &__filter-icon {
      right: 25px;
    }

    &__item-icon {
      display: none;
    }

    &__address-list {
      max-height: 296px;
    }
  }
}
</style>
